import type { FaireProductEntity } from "../../entity_types/product";

export const p_pq94p3qcyx: FaireProductEntity = {
  token: "p_pq94p3qcyx",
  type: "product",
  name: "MYRRH - 12oz CROSS CANDLE",
  brandToken: "b_7jgns9vu20",
  brandName: "Abba Christian Products",
  imageUrl:
    "https://cdn.faire.com/fastly/9dee4f52c47935ed5c550a8452b29a76cac45a4f88f063707e38e29f51faf24a.jpeg",
  galleryImageUrls: [],
  priceDollars: 12,
  description:
    "A radiant jeweled cross made of shimmering iridescent rhinestones, centered with a multicolor faceted gem. Each arm is lined with tightly set stones, creating a bright, elegant sparkle that stands out beautifully! Poured in our popular Myrrh fragrance. \n\nThe candle, measuring 3.5 x 3.5 x 3.25,  is hand poured with our eco-friendly soy wax blend and can be used with votives or tea lights for continued enjoyment.  Approx. burn time of 20-24 hrs. ",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:45.429Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
